import styled from "styled-components";
import H1 from "../H1";

const MemberH1 = styled(H1)`
  color: #06a7ed;
  display: inline;
`;

export default MemberH1;
